module.exports = __webpack_public_path__ + "img/Piece-18-Inspect-Portrait.532c56f6.png";